import React, { useState, useEffect } from 'react';
import { db, collection, getDocs, doc, updateDoc } from '../firebase';  // firebase.js dosyasından import ediyoruz
import './admins.css';  // CSS dosyasını import ediyoruz

const AdminList = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  // Kullanıcıları Firestore'dan alıyoruz
  useEffect(() => {
    const fetchAdmins = async () => {
      const querySnapshot = await getDocs(collection(db, 'users'));
      const adminsList = [];

      querySnapshot.forEach((doc) => {
        const user = doc.data();
        if (user.role === 'admin') {
          adminsList.push({ id: doc.id, ...user });
        }
      });

      setAdmins(adminsList);
      setLoading(false);
    };

    fetchAdmins();
  }, []);

  // Adminlik statüsünü değiştirme
  const toggleAdminRole = async (userId) => {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      role: 'user', // adminlik statüsünü "user" olarak değiştiriyoruz
    });

    // Adminler listesinden çıkarıyoruz
    setAdmins((prevAdmins) => prevAdmins.filter((admin) => admin.id !== userId));
  };

  return (
    <div className="admincontainer">
    <div className="admin-list">
      <h1 className="title">Admin Listesi</h1>
      {loading ? (
        <p className="loading">Yükleniyor...</p>
      ) : (
        <ul className="admin-items">
          {admins.map((admin) => (
            <li className="admin-item" key={admin.id}>
              <span className="admin-name">{admin.firstName} {admin.lastName}</span>
              <button
                className="remove-admin-btn"
                onClick={() => toggleAdminRole(admin.id)}
              >
                Adminliği Al
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
    </div>
  );
};

export default AdminList;
